export const IdTypeValues = ['CC', 'NIT', 'CE', 'Pasaporte', 'RUT'] as const
export type IdType = (typeof IdTypeValues)[number]
